import { Link } from "react-router-dom";
import { ReactComponent as Arrow } from 'assets/icons/button/arrow.svg'
import { ReactComponent as ArrowRightUp } from "assets/icons/button/arrow-up-right.svg";
import { getImageUrl } from "helpers";
import { setActiveNavigationIndex, setMobileMenuOpen } from "store/slices/UI-Slice";
import { useDispatch } from 'react-redux';


const HeaderNavigationLink = ({ data, withColumn = false, withUpArrow = false, onClick }) => {
    const dispatch = useDispatch()
    const { title, description, link, icon } = data
    const handleClick = () => {
        if (onClick) {
            onClick();
            dispatch(setMobileMenuOpen(false));
            dispatch(setActiveNavigationIndex(null));
        }
    };
    const imageUrl = getImageUrl(icon)

    return (
        <Link to={link} onClick={handleClick} className={`header-nav__item__dropdown-item ${withColumn ? 'col-6' : ''}`}>
            <div className="header-nav__item__dropdown-item__icon">
                <img src={imageUrl} alt="" />
            </div>
            <div className="header-nav__item__dropdown-item__body">
                <div className="button-text">{title}{withUpArrow ? <ArrowRightUp className="up-arrow" /> : <Arrow className='arrow' />} </div>
                {description && <div className="body4">{description}</div>}
            </div>
        </Link>
    );
}

export default HeaderNavigationLink;